import { useAuth } from '@/shared/auth';
import { FEATURES_WITH_UPGRADE_PROMPT } from './featuresWithUpgradePrompt';
import { getRequiredTier } from './getRequiredTier';
import type { SubscriptionFeature, SubscriptionTier } from './types';

export type FeatureGateState =
  | { enabled: true }
  | {
      enabled: false;
      /** Lowest tier that would unlock the feature. */
      requiredTier: SubscriptionTier;
      /** Feature key for `FeatureUpgradePrompt`, or `null` when the feature has no full-page prompt. */
      featureGateKey: SubscriptionFeature | null;
    };

/**
 * Resolves whether the current user's tier grants a feature. The single seam
 * for tier/feature gating on the frontend — see ADR-0010.
 */
export const useFeatureGate = (feature: SubscriptionFeature): FeatureGateState => {
  const { sessionUser } = useAuth();

  if (sessionUser?.hasFeature(feature) ?? false) {
    return { enabled: true };
  }

  return {
    enabled: false,
    requiredTier: getRequiredTier(feature),
    featureGateKey: FEATURES_WITH_UPGRADE_PROMPT.has(feature) ? feature : null,
  };
};
